var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertGold = function SvgAlertGold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 72 72"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#827127",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M36 27v12m.001 12v.03m-20.98 11.957h41.96c6.944 0 11.273-7.533 7.774-13.533L43.775 13.47c-3.472-5.956-12.077-5.956-15.55 0L7.246 49.454c-3.498 6 .83 13.533 7.775 13.533M36.75 51a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"
  })));
};
export default SvgAlertGold;